import React from 'react';
import {Tooltip} from '@mui/material';
import {makeStyles} from 'tss-react/mui';
import {FormattedMessage} from 'react-intl';
import {getImageByAgent} from '../config/agent';

const LightbulbImg = getImageByAgent('lightbulb.gif');
const LightbulbTooltip = ({
  name,
  placement,
  hideTooltip,
}) => {
  const {classes} = useStyles();
  if (hideTooltip) {
    return null;
  }
  return (
    <Tooltip
      className={classes.tooltip}
      placement={placement ? placement : 'left'}
      title={<FormattedMessage id={name}/>}

    >
      <span>
        <img src={LightbulbImg} alt='' aria-hidden='true' />
      </span>
    </Tooltip>
  );
};
const useStyles = makeStyles()((theme) => ({
  tooltip: {
    fontSize: theme.typography.fontSize,
    color: theme.palette.secondary.main,
    display: 'inline-block',
    transition: '0.3s all',
    borderBottom: '2px solid transparent',
    padding: '5px 0 0',
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
    '& img': {
      height: '35px',
    },
  },
}));

export default LightbulbTooltip;